import Data from 'data';

function varSpeed(stats) {
  switch (stats.info.weaponClass) {
  case "swing": return 57.142834;
  case "thrust": return 56.842068;
  case "swing2h": return 57.272724;
  case "thrust2h": return 57.272724;
  case "staff": return 57.272724;
  case "dualwield": return 57.142834;
  default: return 56.470570;
  }
}

export const skills = {
  bash: {
    active: true,
    params: [{rune: "b", min: 0, max: 3, val: 3, name: "Stacks"},
             {min: 0, max: 40, name: "Fury", buffs: false, show(rune, stats) {
               return !!stats.leg_bladeofthewarlord;
             }}],
    info(rune, stats) {
      const fpa = varSpeed(stats);
      let res;
      switch (rune) {
      case "x": res = {"Damage": {elem: "phy", coeff: 3.2}}; break;
      case "c": res = {"Damage": {elem: "col", coeff: 3.2}}; break;
      case "a": res = {"Damage": {elem: "lit", coeff: 3.2}}; break;
      case "b": res = {"Damage": {elem: "phy", coeff: 3.2}}; break;
      case "d": res = {"Damage": {elem: "fir", coeff: 3.2}}; break;
      case "e": res = {"Damage": {elem: "fir", coeff: 3.2}, "Shockwave Damage": {elem: "fir", coeff: 1}}; break;
      default: return;
      }
      if (stats.leg_bladeofthewarlord) {
        const pct = {};
        pct[Data.itemById.P4_Unique_Mighty_1H_005.name] = stats.leg_bladeofthewarlord * this.params[1].val / 40;
        res["Damage"].percent = pct;
        if (rune === "e") res["Shockwave Damage"].percent = pct;
      }
      return Object.assign({"DPS": {sum: true, "Damage": {speed: (stats.leg_oathkeeper ? 1.5 : 1), fpa: fpa, round: "up"}}}, res);
    },
    buffs(rune, stats) {
      if (rune === "a") return {chctaken: 10};
      if (rune === "b") return {damage: this.params[0].val * 4};
    },
  },
  cleave: {
    params: [{min: 0, max: "maxfury", name: "Fury", buffs: false, show(rune, stats) {
               return !!stats.leg_dishonoredlegacy;
             }}],
    info(rune, stats) {
      let fpa;
      switch (stats.info.weaponClass) {
      case "swing": fpa = 57.857117; break;
      case "thrust": fpa = 57.857121; break;
      case "swing2h": fpa = 57.857128; break;
      case "thrust2h": fpa = 57.857128; break;
      case "staff": fpa = 57.931034; break;
      case "dualwield": fpa = 57.857124; break;
      default: fpa = 57.857117;
      }
      let res;
      switch (rune) {
      case "x": res = {"Damage": {elem: "phy", coeff: 2}}; break;
      case "e": res = {"Damage": {elem: "fir", coeff: 2}, "Explosion Damage": {elem: "fir", coeff: 1.6}}; break;
      case "d": res = {"Damage": {elem: "fir", coeff: 2}}; break;
      case "c": res = {"Damage": {elem: "phy", coeff: 2}, "Critical Damage": {elem: "phy", coeff: 0.8}}; break;
      case "a": res = {"Damage": {elem: "lit", coeff: 2.35}}; break;
      case "b": res = {"Damage": {elem: "col", coeff: 2}}; break;
      default: return;
      }
      if (stats.leg_dishonoredlegacy) {
        const percent = {};
        percent[Data.itemById.Unique_Mighty_1H_103_x1.name] =
          stats.leg_dishonoredlegacy * Math.max(0, (stats.maxfury - this.params[0].val) / stats.maxfury);
        for (const k in res) {
          res[k].percent = percent;
        }
      }
      const dps = {"DPS": {sum: true, "Damage": {speed: (stats.leg_oathkeeper ? 1.5 : 1), fpa: fpa, round: "up"}}};
      if (rune === "c") {
        dps["DPS"]["Critical Damage"] = Object.assign({nobp: true, factor: 0.01 * stats.final.chc}, dps["DPS"]["Damage"]);
      }
      return Object.assign(dps, res);
    },
    active: true,
    buffs: {
      b: {dmgtaken: 10},
    },
  },
  frenzy: {
    params: [{min: 0, max: "(leg_bastionsrevered_p68||leg_bastionsrevered)?10:5", name: "Stacks", buffs: false}],
    info(rune, stats) {
      const fpa = varSpeed(stats);
      const stacks = this.params[0].val;
      let res;
      if (stats.leg_theundisputedchampion || stats.leg_theundisputedchampion_p68) {
        res = {"Damage": {elem: "max", coeff: 2.2}, "Sidearm Damage": {elem: "max", coeff: 3}};
      } else {
        switch (rune) {
        case "x": res = {"Damage": {elem: "phy", coeff: 2.2}}; break;
        case "b": res = {"Damage": {elem: "col", coeff: 2.2}, "Sidearm Damage": {elem: "col", coeff: 3}}; break;
        case "e": res = {"Damage": {elem: "col", coeff: 2.2}}; break;
        case "c": res = {"Damage": {elem: "phy", coeff: 2.2}}; break;
        case "d": res = {"Damage": {elem: "lit", coeff: 2.2}}; break;
        case "a": res = {"Damage": {elem: "fir", coeff: 2.2}}; break;
        default: return;
        }
      }
      let tdmg = "Damage";
      if (stats.leg_bastionsrevered_p68) {
        tdmg = "Total Damage";
        res[tdmg] = {sum: true, "Damage": {count: this.params[0].val}};
      }
      const dps = {"DPS": {sum: true}};
      dps["DPS"][tdmg] = {speed: (stats.leg_oathkeeper ? 1.5 : 1), ias: stacks * 15, fpa: fpa, round: "up"};
      if (rune === "b" || stats.leg_theundisputedchampion || stats.leg_theundisputedchampion_p68) {
        dps["DPS"]["Sidearm Damage"] = Object.assign({nobp: true, count: 0.25}, dps["DPS"][tdmg]);
      }
      return Object.assign(dps, res);
    },
    active: true,
    buffs(rune, stats) {
      const res = {};
      if (rune === "a" || stats.leg_theundisputedchampion || stats.leg_theundisputedchampion_p68) {
        res.damage = this.params[0].val * 2.5;
      }
      if (rune === "c" || stats.leg_theundisputedchampion || stats.leg_theundisputedchampion_p68) {
        res.extrams = this.params[0].val * 5;
      }
      return res;
    },
  },
  weaponthrow: {
    info: {
      "*": {"DPS": {sum: true, "Damage": {speed: "leg_oathkeeper?1.5:1", ias: "leg_thethreehundredthspear_p73?200:0", fpa: 57.777767, round: "up"}}},
      x: {"Damage": {elem: "phy", coeff: 2.75}},
      a: {"Damage": {elem: "lit", coeff: 4}},
      b: {"Damage": {elem: "fir", coeff: 2.75}},
      c: {"Damage": {elem: "phy", coeff: 2.75}},
      e: {"Damage": {elem: "phy", coeff: 2.75}},
      d: {"Damage": {elem: "fir", coeff: 2.75}},
    },
  },
  hammeroftheancients: {
    params: [{min: 0, max: "maxfury", name: "Fury", buffs: false}],
    info: {
      "*": {"Cost": {cost: 20}, "DPS": {sum: true, "Damage": {speed: 1, ias: "(leg_bracersofthefirstmen||leg_bracersofthefirstmen_p6)?50:0", fpa: 56.666664, round: "up"}}},
      x: {"Damage": {elem: "phy", coeff: 5.35, chc: "$1/5"}},
      b: {"Damage": {elem: "phy", coeff: 5.35, chc: "$1/5"}, "Shockwave Damage": {elem: "phy", coeff: 5.05}},
      a: {"Damage": {elem: "fir", coeff: 6.4, chc: "$1/5"}},
      c: {"Damage": {elem: "col", coeff: 5.35, chc: "$1/5"}},
      e: {"Damage": {elem: "lit", coeff: 5.35, chc: "$1/5"}},
      d: {"Damage": {elem: "phy", coeff: 5.35, chc: "$1/5"}},
    },
  },
  rend: {
    params: [{min: 1, max: "(leg_lamentation||leg_lamentation_p67)?2:1", name: "Stacks", buffs: false}],
    info: {
      "*": {"Cost": {cost: 20}, "DPS": {sum: true, "Damage": {divide: "leg_ambospride?1:(set_wastes_2pc?15:5)", factor: "$1"}}},
      x: {"Damage": {weapon: "mainhand", elem: "phy", coeff: 11, total: true, factors: {"Extra Duration": "set_wastes_2pc?3:1"}}},
      b: {"Damage": {weapon: "mainhand", elem: "fir", coeff: 11, total: true, factors: {"Extra Duration": "set_wastes_2pc?3:1"}}},
      d: {"Damage": {weapon: "mainhand", elem: "phy", coeff: 11, total: true, factors: {"Extra Duration": "set_wastes_2pc?3:1"}}},
      a: {"Damage": {weapon: "mainhand", elem: "lit", coeff: 13.5, total: true, factors: {"Extra Duration": "set_wastes_2pc?3:1"}}},
      c: {"Damage": {weapon: "mainhand", elem: "col", coeff: 11, total: true, factors: {"Extra Duration": "set_wastes_2pc?3:1"}}},
      e: {"Damage": {weapon: "mainhand", elem: "phy", coeff: 11, total: true, factors: {"Extra Duration": "set_wastes_2pc?3:1"}}},
    },
    active: true,
    buffs: {
      c: {dmgtaken: 10},
    },
  },
  seismicslam: {
    active: true,
    activetip: "First 10 enemies",
    activeshow(rune, stats) {
      return !!(stats.leg_bracersofdestruction || stats.leg_bracersofdestruction_p6 || stats.leg_bracersofdestruction_p67);
    },
    params: [{rune: "b", min: 0, max: "maxfury", name: "Fury", buffs: false}],
    info(rune, stats) {
      let res;
      switch (rune) {
      case "x": res = {"Damage": {elem: "phy", coeff: 6.2}}; break;
      case "c": res = {"Cost": {cost: 22}, "Damage": {elem: "lit", coeff: 6.2}}; break;
      case "a": res = {"Damage": {elem: "fir", coeff: 7.35}}; break;
      case "b": res = {"DPS": {sum: true, "Damage": {speed: 1, fpa: 58.666656, round: "up"}}, "Damage": {elem: "phy", coeff: 6.2}}; break;
      case "d": res = {"Damage": {elem: "phy", coeff: 6.2}}; break;
      case "e": res = {"Damage": {elem: "col", coeff: 7.55}}; break;
      default: return;
      }
      if (rune === "b" && this.params[0].val) {
        res["Rumble Damage"] = {elem: "phy", coeff: 0.15 * this.params[0].val};
        res["DPS"]["Rumble Damage"] = {speed: 1, fpa: 58.666656, round: "up", nobp: true};
      }
      if (this.active && (stats.leg_bracersofdestruction || stats.leg_bracersofdestruction_p6 || stats.leg_bracersofdestruction_p67)) {
        res["Damage"].percent = {[Data.itemById.P3_Unique_Bracer_104.name]: (stats.leg_bracersofdestruction || stats.leg_bracersofdestruction_p6 || stats.leg_bracersofdestruction_p67)};
        if (res["Rumble Damage"]) res["Rumble Damage"].percent = Object.assign({}, res["Damage"].percent);
      }
      const rcr = {};
      if (stats.leg_furyofthevanishedpeak_p6) rcr.leg_furyofthevanishedpeak_p6 = 50;
      else if (stats.leg_furyofthevanishedpeak_p2) rcr.leg_furyofthevanishedpeak_p2 = stats.leg_furyofthevanishedpeak_p2;
      else if (stats.leg_furyofthevanishedpeak) rcr.leg_furyofthevanishedpeak = stats.leg_furyofthevanishedpeak;
      res = Object.assign({"Cost": {cost: 30, rcr: rcr}, "DPS": {sum: true, "Damage": {speed: 1, fpa: 58.666656, round: "up"}}}, res);
      if (stats.leg_fjordcutter_p67) {
        res["DPS"]["Damage"].ias = 50;
        if (res["DPS"]["Rumble Damage"]) {
          res["DPS"]["Rumble Damage"].ias = 50;
        }
      }
      return res;
    },
  },
  whirlwind: {
    info(rune, stats) {
      let res;
      switch (rune) {
      case "x": res = {"Tick Damage": {elem: "phy", coeff: 3.4}}; break;
      case "b": res = {"Tick Damage": {elem: "phy", coeff: 3.4}}; break;
      case "c": res = {"Tick Damage": {elem: "col", coeff: 3.4}}; break;
      case "e": res = {"Tick Damage": {elem: "phy", coeff: 3.4}}; break;
      case "d": res = {"Tick Damage": {elem: "lit", coeff: 3.4}}; break;
      case "a": res = {"Tick Damage": {elem: "fir", coeff: 4}}; break;
      default: return;
      }
      res = Object.assign({"Cost": {cost: 7 / stats.info.aps + 3, fpa: 40}}, res);
      res["Tick Damage"].divide = {"Base Speed": 1.5};
      if (stats.leg_skullgrasp) {
        res["Tick Damage"].addcoeff = [stats.leg_skullgrasp / 100];
      }
      if (rune === "b" || stats.set_wastes_6pc) {
        res["Tornado Damage"] = {elem: res["Tick Damage"].elem, coeff: 1.8};
      }
      res["DPS"] = {sum: true, "Tick Damage": {speed: 1, fpa: 40}};
      if (res["Tornado Damage"]) res["DPS"]["Tornado Damage"] = {speed: 1, fpa: 30};
      return res;
    },
    active: true,
    buffs(rune, stats) {
      if (stats.set_bulkathos_2pc) return {extrams: 45, ias: 45};
    },
  },
  ancientspear: {
    active: true,
    activetip: "5 or fewer targets",
    activeshow(rune, stats) {
      return !!(rune === "b" && (stats.leg_skularssalvation || stats.leg_skularssalvation_p73));
    },
    params: [{rune: "b", min: "25*(1-0.01*rcr_fury)-rcrint", max: "maxfury+(leg_arreatslaw_p73?200:0)", name: "Fury", buffs: false}],
    info(rune, stats) {
      let res;
      switch (rune) {
      case "x": res = {"Damage": {elem: "phy", coeff: 5}}; break;
      case "d": res = {"Damage": {elem: "phy", coeff: 5}}; break;
      case "a": res = {"Damage": {elem: "phy", coeff: 5}}; break;
      case "c": res = {"Damage": {elem: "fir", coeff: 6.4}}; break;
      case "b": res = {"Damage": {elem: "phy", coeff: 5, addcoeff: [[0.2, this.params[0].val - 25 * (1 - 0.01 * (stats.rcr_fury || 0)) + (stats.rcrint || 0)]]}}; break;
      case "e": res = {"Damage": {elem: "phy", coeff: 5}}; break;
      default: return;
      }
      if (rune === "b" && stats.leg_skularssalvation) {
        res["Damage"].percent = {[Data.itemById.P4_Unique_Bracer_101.name]: 100 + (this.active ? 2 * stats.leg_skularssalvation : 0)};
      } else if (rune === "b" && stats.leg_skularssalvation_p73 && this.active) {
        res["Damage"].percent = {[Data.itemById.P4_Unique_Bracer_101.name]: 100};
      }
      res = Object.assign({"Cost": {cost: 25}}, res);
      return res;
    },
  },
  groundstomp: {
    info: {
      "*": {"Cooldown": {cooldown: 12}},
      a: {"Damage": {weapon: "mainhand", elem: "fir", coeff: 5.75}},
      e: {"Cooldown": {cooldown: 8}},
    },
  },
  leap: {
    info: {
      "*": {"Cooldown": {cooldown: 10}, "Damage": {weapon: "mainhand", elem: "phy", coeff: 1.8}},
      b: {"Damage": {weapon: "mainhand", elem: "phy", coeff: 4.5}},
    },
    active: false,
    buffs(rune, stats) {
      if (rune === "d" || stats.set_earth_4pc) return {armor_percent: 150 * (stats.set_earth_4pc ? 2.5 : 1)};
    },
  },
  sprint: {
    info: {
      "*": {"Cost": {cost: 20}},
      c: {"Tornado Tick Damage": {elem: "phy", coeff: 1.8, divide: {"Base Speed": 3}}, "Tornado DPS": {sum: true, "Tornado Tick Damage": {speed: 1, fpa: 20}}},
      e: {"Knockback Damage": {elem: "phy", coeff: 0.25}},
    },
    active: false,
    buffs: {
      x: {extrams: 30},
      b: {extrams: 30, dodge: 12},
      c: {extrams: 30},
      a: {extrams: 40},
      e: {extrams: 30},
      d: {extrams: 30},
    },
  },
  ignorepain: {
    info: {
      "*": {"Uptime": {duration: "5+leg_prideofcassius", cooldown: 30}},
      b: {"Uptime": {duration: "7+leg_prideofcassius", cooldown: 30}},
    },
    active: false,
    buffs: {
      x: {dmgred: 50},
      d: {dmgred: 50, extrams: 40},
      b: {dmgred: 50},
      e: {dmgred: 50, lifefury: 5364},
      c: {dmgred: 50},
      a: {dmgred: 50},
    },
  },
  overpower: {
    params: [{min: 0, max: 20, val: 0, name: () => Data.itemById.P43_Unique_Belt_001_x1.name, buffs: false, show(rune, stats) {
               return !!stats.leg_saffronwrap;
             }}],
    info(rune, stats) {
      const res = {"Cooldown": {cooldown: 12}, "Damage": {weapon: "mainhand", elem: "phy", coeff: 3.8}};
      if (rune === "a") res["Damage"].elem = "lit";
      if (rune === "e") res["Damage"].elem = "col";
      if (rune === "c") {
        res["Damage"].elem = "fir";
        res["Damage"].coeff = 7.6;
      }
      if (stats.leg_saffronwrap && this.params[0].val) {
        res["Damage"].percent = {[Data.itemById.P43_Unique_Belt_001_x1.name]: stats.leg_saffronwrap * this.params[0].val};
      }
      return res;
    },
    active: false,
    buffs: {
      a: {chc: 8},
    },
  },
  revenge: {
    info: {
      x: {"Damage": {weapon: "mainhand", elem: "phy", coeff: 3}},
      d: {"Damage": {weapon: "mainhand", elem: "phy", coeff: 3}},
      e: {"Damage": {weapon: "mainhand", elem: "col", coeff: 3}},
      a: {"Damage": {weapon: "mainhand", elem: "fir", coeff: 7}},
      c: {"Damage": {weapon: "mainhand", elem: "lit", coeff: 3}},
      b: {"Damage": {weapon: "mainhand", elem: "phy", coeff: 3}},
    },
    active: false,
    buffs: {
      e: {chc: 8},
    },
  },
  furiouscharge: {
    info(rune, stats) {
      const elem = Data.skilltips.barbarian.furiouscharge.elements[rune];
      const coeff = (rune === "a" || stats.set_raekor_4pc ? 10.5 : 6);
      const res = {"Cooldown": {cooldown: 10}, "Damage": {elem, weapon: "mainhand", coeff}};
      if (stats.leg_vileward) {
        res["Extra Damage per Enemy"] = {elem, coeff, factors: {"Vile Ward": stats.leg_vileward * 0.01}};
      }
      if (stats.leg_standoff || stats.leg_standoff_p6) {
        const pct = {[Data.itemById.P4_Unique_Polearm_01.name]: (stats.ms || 0) * 0.01 * (stats.leg_standoff || stats.leg_standoff_p6)};
        res["Damage"].percent = pct;
        if (stats.leg_vileward) res["Extra Damage per Enemy"].percent = pct;
      }
      return res;
    },
  },
  avalanche: {
    info: {
      "*": {"Cooldown": {cooldown: 30}},
      x: {"Damage": {weapon: "mainhand", elem: "phy", coeff: 24}},
      c: {"Damage": {weapon: "mainhand", elem: "fir", coeff: 66, total: true}},
      d: {"Damage": {weapon: "mainhand", elem: "phy", coeff: 24}},
      b: {"Damage": {weapon: "mainhand", elem: "col", coeff: 28}},
      e: {"Damage": {weapon: "mainhand", elem: "phy", coeff: 24}},
      a: {"Damage": {weapon: "mainhand", elem: "col", coeff: 24}},
    },
  },
  threateningshout: {
    info: {
      "*": {"Cooldown": {cooldown: 10}},
    },
    active: true,
    buffs(rune, stats) {
      if (rune === "d") return {dmgtaken: (stats.set_savages_2pc ? 2 : 1) * 25};
    },
  },
  battlerage: {
    active: true,
    params: [
      {rune: "d", val: 0, min: 0, max: 20, name: "Nearby Enemies", inf: true},
    ],
    info: {
      "*": {"Cost": {cost: 20}},
    },
    buffs(rune, stats) {
      const mult = (stats.set_savages_2pc ? 2 : 1);
      const res = {damage: mult * 10, chc: mult * 3};
      if (rune === "a") res.damage = mult * 15;
      if (rune === "b") res.extrams = mult * 15;
      if (rune === "d") res.chc += mult * this.params[0].val;
      return res;
    },
  },
  warcry: {
    info: {
      "*": {"Cooldown": {cooldown: 20}},
    },
    active: true,
    buffs(rune, stats) {
      const mult = (stats.set_savages_2pc ? 2 : 1);
      switch (rune) {
      case "x": return {armor_percent: mult * 20};
      case "a": return {armor_percent: mult * 80};
      case "d": return {armor_percent: mult * 20};
      case "e": return {armor_percent: mult * 20, life: mult * 10, regen: mult * 13411};
      case "b": return {armor_percent: mult * 20, dodge: mult * 30};
      case "c": return {armor_percent: mult * 20, resist_percent: mult * 20};
      // no default
      }
    },
  },
  earthquake: {
    info: {
      "*": {"Cooldown": {cooldown: 60}},
      x: {"Damage": {weapon: "mainhand", elem: "fir", coeff: 48, total: true}},
      b: {"Damage": {weapon: "mainhand", elem: "fir", coeff: 48, total: true}, "Tremor Damage": {weapon: "mainhand", elem: "fir", coeff: 3}, "Total Damage": {sum: true, "Damage": {}, "Tremor Damage": {count: 30}}},
      c: {"Damage": {weapon: "mainhand", elem: "col", coeff: 48, total: true}},
      d: {"Cooldown": {cooldown: 30}, "Damage": {weapon: "mainhand", elem: "lit", coeff: 48, total: true}},
      a: {"Damage": {weapon: "mainhand", elem: "fir", coeff: 60, total: true}},
      e: {"Damage": {weapon: "mainhand", elem: "phy", coeff: 48, total: true}},
    },
  },
  calloftheancients: {
    info(rune, stats) {
      let res;
      const speed = stats.leg_furyoftheancients_p67 ? 2 : 1;
      switch (rune) {
      case "x": res = {"Damage": {weapon: "mainhand", elem: "phy", pet: true, coeff: 2.7}, "DPS": {sum: true, "Damage": {speed: speed, pet: 60, count: 3}}}; break;
      case "b": res = {"Damage": {weapon: "mainhand", elem: "fir", pet: true, coeff: 5.4}, "DPS": {sum: true, "Damage": {speed: speed, pet: 60, count: 3}}}; break;
      case "d": res = {"Damage": {weapon: "mainhand", elem: "col", pet: true, coeff: 2.7}, "DPS": {sum: true, "Damage": {speed: speed, pet: 60, count: 3}}}; break;
      case "a": res = {"Damage": {weapon: "mainhand", elem: "phy", pet: true, coeff: 2.7}, "DPS": {sum: true, "Damage": {speed: speed, pet: 60, count: 3}}}; break;
      case "c": res = {"Damage": {weapon: "mainhand", elem: "phy", pet: true, coeff: 2.7}, "DPS": {sum: true, "Damage": {speed: speed, pet: 60, count: 3}}}; break;
      case "e": res = {"Damage": {weapon: "mainhand", elem: "lit", pet: true, coeff: 2.7}, "DPS": {sum: true, "Damage": {speed: speed, pet: 60, count: 3}}}; break;
      default: return;
      }
      if (!stats.set_immortalking_2pc) {
        res["Uptime"] = {duration: 20, cooldown: 120};
      } else {
        res["Cooldown"] = {cooldown: 120};
      }
//      if (stats.set_immortalking_4pc) {
//        res["Cleave Damage"] = Object.assign({}, res["Damage"], {coeff: 6});
//      }
      return res;
    },
    active: false,
    activeshow(rune, stats) {
      return !stats.set_immortalking_2pc;
    },
    buffs: {
      a: {lifefury: 966},
      d: {chctaken: 10},
      e: {dmgred: 50},
    },
  },
  wrathoftheberserker: {
    params: [{min: 0, max: 50, name: "Tempest Rhythm", show(rune, stats) {
               return !!stats.seasontheme_019;
             }}],
    info(rune, stats) {
      const res = {};
      if (!stats.set_immortalking_4pc) {
        res["Uptime"] = {duration: 20, cooldown: 120};
      } else {
        res["Cooldown"] = {cooldown: 120};
      }
      if (stats.leg_morticksbrace || rune === "b") {
        res["Activation Damage"] = {weapon: "mainhand", elem: "fir", coeff: 34};
      }
      if (stats.leg_morticksbrace || rune === "e") {
        res["Eruption Damage"] = {weapon: "mainhand", elem: "phy", coeff: 3};
      }
      if (Object.keys(res).length) {
        return res;
      }
    },
    active: false,
    buffs(rune, stats) {
      let result;
      if (stats.leg_morticksbrace) {
        result = {ccr: 100, dmgmul: 50, dmgred: 50, lifefury: 5364, chc: 10, ias: 25, dodge: 20, extrams: 20};
      } else {
        switch (rune) {
        case "x": result = {ccr: 100, chc: 10, ias: 25, dodge: 20, extrams: 20}; break;
        case "b": result = {ccr: 100, chc: 10, ias: 25, dodge: 20, extrams: 20}; break;
        case "a": result = {ccr: 100, dmgmul: 50, chc: 10, ias: 25, dodge: 20, extrams: 20}; break;
        case "e": result = {ccr: 100, chc: 10, ias: 25, dodge: 20, extrams: 20}; break;
        case "c": result = {ccr: 100, dmgred: 50, chc: 10, ias: 25, dodge: 20, extrams: 20}; break;
        case "d": result = {ccr: 100, lifefury: 5364, chc: 10, ias: 25, dodge: 20, extrams: 20}; break;
        // no default
        }
      }
      if (stats.seasontheme_019) {
        result.dmgtaken = 2 * this.params[0].val;
      }
      return result;
    },
  },
};

export const passives = {
  poundofflesh: {
    params: [{min: 0, max: 5, val: 0, name: "Stacks"}],
    buffs(stats) {
      return {regen_percent: this.params[0].val * 2, extrams: this.params[0].val * 4};
    },
  },
  ruthless: {
    active: false,
    buffs: {dmgmul: 40},
  },
  nervesofsteel: {
  },
  weaponsmaster: {
    buffs(stats) {
      switch (stats.info.mainhand.type) {
      case "sword":
      case "sword2h":
      case "dagger":
      case "championsword":
        return {damage: 8};
      case "mace":
      case "mace2h":
      case "axe":
      case "axe2h":
      case "flyingaxe":
        return {chc: 5};
      case "spear":
      case "polearm":
        return {ias: 8};
      // no default
      }
    },
  },
  inspiringpresence: {
    buffs(stats) {
      if (stats.skills.battlerage || stats.skills.threateningshout || stats.skills.warcry) {
        return {regen_percent: 3};
      }
    },
  },
  berserkerrage: {
    active: true,
    buffs: {damage: 25},
  },
  bloodthirst: {
    buffs(stats) {
      return {lifefury: 966 + 0.01 * (stats.healbonus || 0)};
    },
  },
  animosity: {
    buffs: {maxfury: 20, resourcegen: 10},
  },
  superstition: {
    buffs: {nonphys: 20},
  },
  toughasnails: {
    buffs: {armor_percent: 25, thorns_multiply: 100},
  },
  noescape: {
    active: true,
    buffs: {dmgmul: {skills: ["weaponthrow", "ancientspear", "avalanche", "seismicslam"], percent: 30}},
  },
  relentless: {
    active: false,
    buffs: {rcr: 50, lpfs_percent: 100, dmgred: 50},
  },
  brawler: {
    active: false,
    buffs: {damage: 20},
  },
  juggernaut: {
    buffs: {ccr: 50},
  },
  unforgiving: {
  },
  boonofbulkathos: {
    buffs: {
      skill_barbarian_earthquake_cooldown: 15,
      skill_barbarian_calloftheancients_cooldown: 30,
      skill_barbarian_wrathoftheberserker_cooldown: 30,
    },
  },
  earthenmight: {
  },
  swordandboard: {
    buffs(stats) {
      if (stats.info.ohtype === "shield") {
        return {dmgred: 30, rcr: 20};
      }
    },
  },
  rampage: {
    params: [{val: 0, min: 0, max: 25, name: "Stacks"}],
    buffs(stats) {
      return {str_percent: this.params[0].val};
    },
  },
};

export const partybuffs = {
  bash: {
    runelist: "a",
  },
  cleave: {
    runelist: "b",
  },
  rend: {
    runelist: "c",
  },
  ignorepain: {
    runelist: "c",
    buffs: {c: {dmgred: 25}},
  },
  warcry: {
    runelist: "*",
    boxnames: ["Horde of the Ninety Savages (2pc)"],
    buffs(rune, stats) {
      const mult = this.boxvals[0] ? 2 : 1;
      switch (rune) {
      case "x": return {armor_percent: mult * 20};
      case "a": return {armor_percent: mult * 80};
      case "d": return {armor_percent: mult * 20};
      case "e": return {armor_percent: mult * 20, life: mult * 10, regen: mult * 13411};
      case "b": return {armor_percent: mult * 20, dodge: mult * 30};
      case "c": return {armor_percent: mult * 20, resist_percent: mult * 20};
      // no default
      }
    },
  },
  threateningshout: {
    runelist: "d",
    boxnames: ["Horde of the Ninety Savages (2pc)"],
    buffs(rune, stats) {
      if (rune === "d") return {dmgtaken: (this.boxvals[0] ? 2 : 1) * 25};
    },
  },
  calloftheancients: {
    runelist: "d",
  },
  inspiringpresence: {
    buffs: {regen_percent: 3},
  },
};
